import { render, staticRenderFns } from "./Tx.vue?vue&type=template&id=7c164b36&scoped=true"
import script from "./Tx.vue?vue&type=script&lang=js"
export * from "./Tx.vue?vue&type=script&lang=js"
import style0 from "./Tx.vue?vue&type=style&index=0&id=7c164b36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c164b36",
  null
  
)

export default component.exports